export default __webpack_public_path__ + "static/sprite-063fd57f980731595727f79728906e5c.svg";